export default __webpack_public_path__ + "static/media/pool.1d9308b7.jpg";